import axios from 'axios';
import {
    interceptorsRequest,
    interceptorsRequestError,
    interceptorsResponse,
    interceptorsResponseError,
} from './interceptors';

let APIV3 = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL_V3,
    responseType: 'json',
});
APIV3.defaults.headers.post['content-type'] = 'application/json';
APIV3.defaults.headers.get['Accept'] = 'application/json';

APIV3.interceptors.request.use(
    (request) => {
        const interceptorsReq = interceptorsRequest(request);
        return interceptorsReq;
    },
    (error) => {
        const promiseError = interceptorsRequestError(error);
        return promiseError;
    }
);

APIV3.interceptors.response.use(
    (response) => {
        const interceptorsRes = interceptorsResponse(response);
        return interceptorsRes;
    },
    (error) => {
        const responseError = interceptorsResponseError(error);
        return responseError;
    }
);

export default APIV3;
